import { render, staticRenderFns } from "./SearchSchema.vue?vue&type=template&id=e92fe60e&scoped=true&"
import script from "./SearchSchema.vue?vue&type=script&lang=ts&"
export * from "./SearchSchema.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e92fe60e",
  null
  
)

export default component.exports